import React from 'react';
import Message, {getMessage} from '../../../common/Message';
import CheckBox from 'epic-diesel-form/src/components/form/CheckBox';

//@ts-ignore
import styles from './DisclaimerSection.pcss';

interface Props {
    userState: any;
    configState: {
        quickLinks: Record<string, string>;
    };
    messages: any;
    disclaimerAccepted: boolean;
    updateForm: (key: string, checked: boolean) => void;
    accept?: string | React.ReactElement;
}

const CODES = {
    header: 'epic.affiliate.signup.disclaimer.header.v2',
    subHeader: 'epic.affiliate.signup.disclaimer.desc.v2',
    accept: 'epic.affiliate.signup.disclaimer.accept.v2'
};

const DisclaimerSection: React.FunctionComponent<Props> = props => {
    const {accept = CODES.accept} = props;

    return (
        <div className={styles.disclaimerSection}>
            <h2>
                <Message code={CODES.header} /> {' *'}
            </h2>

            <p>
                <Message code={CODES.subHeader} />
            </p>

            <div className={styles.container}>
                <div className={styles.disclaimerBody}>{props.children}</div>

                <CheckBox
                    name="disclaimerAccepted"
                    validations="checked"
                    validationError={getMessage(
                        props.messages,
                        'errors.com.epicgames.validation.required_field.v2'
                    )}
                    value={props.disclaimerAccepted}
                    onChange={props.updateForm}>
                    {typeof accept === 'string' ? <Message code={accept} /> : accept}
                </CheckBox>
            </div>
        </div>
    );
};

export default DisclaimerSection;
